import frischoggi from "../assets/frischoggi.webp";
import pralines from "../assets/pralines.webp";
import tablets from "../assets/tablets.webp";
import snacking from "../assets/snacking.webp";
import "./CategoriesStyle.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { filterCategory } from "../redux/categorySlice";

function Categories() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCategoryClick = (categorySelected) => {
    dispatch(filterCategory({ selected: categorySelected }));
    navigate("/catalog");
  };

  return (
    <div className="mb-5 pb-5 container">
      <div>
        <h2 id="our-products" className="mb-40 fw-normal fs-2">
          Our Products
        </h2>
      </div>
      <div className="row d-flex justify-content-evenly  p-0">
        <div
          className="col-md-5 wow fadeInLeft  categorie-div div-fadeInLeft"
          style={{
            cursor: "pointer",
            background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${frischoggi})`,
            backgroundPosition: `center`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
          }}
          onClick={() => {
            handleCategoryClick("frischschoggi");
          }}
        >
          <h2 className="h2" id="categoryTitle">
            FrischSchoggi
          </h2>
          <div className="d-flex"></div>
          {/* <img
            className="img-category"
            id="frischoggi"
            src={frischoggi}
            alt="Logo"
          /> */}
        </div>
        <div
          className="col-md-5 wow fadeInLeft categorie-div div-fadeInLeft"
          style={{
            cursor: "pointer",
            background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${pralines})`,
            backgroundPosition: `center center`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
          }}
          onClick={() => {
            handleCategoryClick("pralines");
          }}
        >
          {/* <img
            className="img-category "
            id="pralines"
            src={pralines}
            alt="Logo"
          ></img */}

          <h2 className="text-white h2" id="categoryTitle">
            Pralinés & Truffles
          </h2>
        </div>
        <div
          className="col-md-5 wow fadeInRight categorie-div div-fadeInRight"
          style={{
            cursor: "pointer",
            background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${tablets})`,
            backgroundPosition: `center`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
          }}
          onClick={() => {
            handleCategoryClick("tablets");
          }}
        >
          {/* <img
            className="img-category "
            id="tablets"
            src={tablets}
            alt="Logo"
          /> */}
          <h2 className="text-white h2" id="categoryTitle">
            Tablets
          </h2>
        </div>

        <div
          className="col-md-5 wow fadeInRight categorie-div div-fadeInRight"
          style={{
            cursor: "pointer",
            background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${snacking})`,
            backgroundPosition: `center center`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
          }}
          onClick={() => {
            handleCategoryClick("snacking");
          }}
        >
          {/* <img
            className="img-category"
            id="snacking"
            src={snacking}
            alt="Logo"
          /> */}
          <h2 className="text-white h2" id="categoryTitle">
            Snacking
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Categories;
